import React, { ReactNode } from 'react';
import { Box, Container, Typography } from '@mui/material';
import logo from '../../logo.svg';

/** Shared dark look for the unauthenticated pages (login, forgot / reset password). */
export const AUTH_BG = '#211D1E';
export const AUTH_FIELD_BG = '#3C3B3D';

export const authTextFieldSx = {
  '& .MuiOutlinedInput-root': {
    // On the root, not just the <input>, so end adornments (show/hide password) share the field's background.
    backgroundColor: AUTH_FIELD_BG,
    '& fieldset': { borderColor: AUTH_FIELD_BG },
    '&:hover fieldset': { borderColor: '#ffffff' },
    '&.Mui-focused fieldset': { borderColor: '#ffffff' },
    '& input': { color: 'white', backgroundColor: AUTH_FIELD_BG },
  },
  '& .MuiInputLabel-root': { color: 'white' },
  '& .MuiInputLabel-root.Mui-focused': { color: 'white' },
};

export const authPrimaryButtonStyle: React.CSSProperties = {
  marginTop: '1rem',
  backgroundColor: 'white',
  color: AUTH_BG,
  fontWeight: 'bold',
};

export const authLinkStyle: React.CSSProperties = { textDecoration: 'none', color: 'white' };

type AuthPageLayoutProps = {
  title: string;
  subtitle?: string;
  children: ReactNode;
};

export const AuthPageLayout = ({ title, subtitle, children }: AuthPageLayoutProps) => (
  <div
    style={{
      backgroundColor: AUTH_BG,
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Container className="d-flex flex-column align-items-center" style={{ maxWidth: '400px', marginTop: '1rem' }}>
      <Box mb={2} style={{ transform: 'translateX(-0.4cm)' }}>
        <img src={logo} alt="Company Logo" style={{ maxWidth: '100%', height: 'auto' }} />
      </Box>
      <Typography variant="h5" component="h1" gutterBottom style={{ color: 'white', fontWeight: 'bold' }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" gutterBottom style={{ color: '#ddd', textAlign: 'center' }}>
          {subtitle}
        </Typography>
      )}
      {children}
    </Container>
  </div>
);
